import { Link } from "react-router-dom";

export default function Logo({ size = 36, className = "", showText = true, to = "/dashboard" }) {
  const content = (
    <div className={`flex items-center gap-3 ${className}`} data-testid="miledeep-logo">
      <div
        className="hd-logo"
        style={{ width: size, height: size, fontSize: Math.round(size * 0.32) }}
      >
        MD
      </div>
      {showText && (
        <div className="min-w-0 text-left">
          <div className="hd-company-name">Miledeep Help Desk</div>
          <div className="hd-powered">Powered by Quantira</div>
        </div>
      )}
    </div>
  );
  if (!to) return content;
  return <Link to={to} className="inline-flex" data-testid="miledeep-logo-link">{content}</Link>;
}
